import apiClient from './client';

// How useful (1-9) an association's finding is for telling its disease apart
// from another disease.

// One item per other disease: {other_disease, average, count, my_rating}.
// average is 0 with count 0 when nobody has rated the pair.
export const getComparisons = (associationId, otherDiseaseIds) =>
  apiClient
    .get(`/associations/${associationId}/comparisons`, {
      params: { disease_ids: otherDiseaseIds.join(',') },
    })
    .then((r) => r.data.items);

// Both return the comparison's new stats
export const rateComparison = (associationId, otherDiseaseId, usefulness) =>
  apiClient
    .put(`/associations/${associationId}/comparisons/${otherDiseaseId}/rating`, { usefulness })
    .then((r) => r.data);

export const clearComparisonRating = (associationId, otherDiseaseId) =>
  apiClient
    .delete(`/associations/${associationId}/comparisons/${otherDiseaseId}/rating`)
    .then((r) => r.data);

// The matrix hover grid: every rated pair of the selected diseases for one
// finding, as {disease_a_id, disease_b_id, average, count} with a < b
export const getFindingComparisons = (findingId, diseaseIds) =>
  apiClient
    .get(`/findings/${findingId}/comparisons`, { params: { disease_ids: diseaseIds.join(',') } })
    .then((r) => r.data.pairs);
